'use client';

import { CurrencyDisplay } from '@flipster/features/src/misc/display';
import { hstack } from '@flipster/styled-system/patterns';

export const CurrencyHeader = ({ currency }: { currency: string }) => {
  return (
    <div className={hstack({ justify: 'space-between', color: 'content.default.level-5' })}>
      <CurrencyDisplay
        currency={currency}
        icon={<CurrencyDisplay.Icon size={32} space={16} />}
        mainLabel={<CurrencyDisplay.Label value='shortName' />}
        css={{ textStyle: 'Text/L/Strong' }}
      />
    </div>
  );
};
